import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import TabsSection from "../../Components/Tabs/TabsSection";
import SideBar from "../SideBar/SideBar";
import { Pages } from "./Pages";
import { HomePageSetup } from "./HomePageSetup";
import { Categories } from "./Categories";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { TermsConditions } from "./TermsConditions";
import Profile from "./profile";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";

export const MarketplaceSetup = () => {
  const [currentTab, setcurrentTab] = useState("");
  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "home-page-setup") {
      setcurrentTab("home-page-setup");
    }
    if (endPath[4] === "pages") {
      setcurrentTab("pages");
    }
    if (endPath[4] === "categories") {
      setcurrentTab("categories");
    }
    if (endPath[4] === "privacy-policy") {
      setcurrentTab("privacy-policy");
    }
    if (endPath[4] === "terms-&-conditions") {
      setcurrentTab("terms-&-conditions");
    }
    if (endPath[4] === "profile") {
      setcurrentTab("profile");
    }
  }, [path]);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Marketplace Setup</p>
          <div className="acc-dashboard mt-4 Marketplace z-10">
            <TabsSection />

            {/* start */}
            {currentTab == "home-page-setup" && <HomePageSetup />}
            {currentTab == "pages" && <Pages />}
            {currentTab == "categories" && <Categories />}
            {currentTab == "privacy-policy" && <PrivacyPolicy />}
            {currentTab == "terms-&-conditions" && <TermsConditions />}
            {currentTab == "profile" && <Profile />}

            {/* end */}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};
